module.exports = __webpack_public_path__ + "static/media/Sean Pittman Headshot.8ee1ca9a.jpeg";